import { NAV_ICONS, type NavIconName } from "@/lib/nav";
import clsx from "clsx";

interface NavIconProps {
  name: NavIconName;
  className?: string;
  size?: number;
}

export function NavIcon({ name, className, size = 20 }: NavIconProps) {
  const Icon = NAV_ICONS[name];
  if (!Icon) return null;
  return (
    <Icon
      className={clsx("shrink-0", className)}
      size={size}
      strokeWidth={1.75}
      aria-hidden
    />
  );
}
